<template>
  <v-navigation-drawer :mini-variant-width="70" app :permanent="!isMobile" :expand-on-hover="!isMobile"
    v-model="isMenuOpen" :style="{ background: 'var(--main-color)', height: '100%' }">
    <v-list>
      <div 
        v-for="(menu, i) in menus" 
        :key="`menu-conteudo-${i}`"
      >
        <list-item 
          v-if="!menu.group" 
          @modalSair="sair" 
          :item="menu" 
        />

        <list-group-item
          v-else
          :menu="menu"
        />
      </div>
    </v-list>
    <ModalSair 
      :modal-aberto="modalSairAberto"
      @close-modal="modalSairAberto = false" 
      @sair="sair" 
      @continuar="modalSairAberto = false"
    />
  </v-navigation-drawer>
</template>

<script>
import ListItem from "./ListItem";
import ListGroupItem from "./ListGroupItem";
import ModalSair from "@/components/ModalSair.vue";

export default {
  name: "NavbarAdmin",
  props: ["toggleMenu"],
  components: { ListItem, ListGroupItem, ModalSair },
  data() {
    return {
      isMenuOpen: false,
      modalSairAberto: false,
      menus: [
        {
          icon: require("@assets/icones/menu-home.svg"),
          titulo: "Home",
          rota: "/admin/home",
        },
        {
          titulo: "Questões",
          icon: require("@assets/icones/menu-modelagem.svg"),
          group: true,
          itens: [
            {
              icon: require("@assets/icones/questao-evoluir.png"),
              titulo: "Evoluir",
              rota: "/admin/relatorio-questoes",
              ativo: false,
            },
            {
              icon: require("@assets/icones/questao-maissaber.png"),
              titulo: "Mais Saber",
              rota: "/admin/mais-saber/relatorio-questoes",
              ativo: false,
            },
          ],
        },
        {
          icon: require("@assets/icones/menu-conteudos.png"),
          titulo: "Conteúdos",
          rota: "/admin/conteudos",
          ativo: false,
        },
        {
          icon: require("@/assets/icones/habilidade-icon.png"),
          titulo: "Habilidades",
          rota: "/admin/crud/habilidade",
          ativo: false,
        },
        {
          titulo: "Relatórios",
          icon: require("@assets/icones/menu-relatorios.svg"),
          group: true,
          itens: [
            {
              icon: require("@/assets/icones/menu-relatorio-questoes.png"),
              titulo: "Relatório de questões e habilidades",
              rota: "/admin/relatorios/questao-habilidade",
              ativo: false,
            },
          ],
        },

        {
          titulo: "Reds",
          icon: require("@assets/icones/menu-recursos-educacionais.svg"),
          group: true,
          itens: [
            {
              icon: require("@/assets/icones/recursos-podcast.svg"),
              titulo: "Podcast",
              rota: "/admin/crud/podcast",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/recursos-audio-ingles.svg"),
              titulo: "Áudios em Inglês e Infantis",
              rota: "/admin/crud/audios-ingles",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/recursos-infograficos.svg"),
              titulo: "Infográficos e Mapas",
              rota: "/admin/crud/infograficos-mapas",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/recursos-sequencia-didatica.svg"),
              titulo: "Sequência Didática",
              rota: "/admin/crud/sequencia-didatica",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/recursos-planejamento.svg"),
              titulo: "Planejamentos",
              rota: "/admin/crud/planejamentos",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/projetos-integradores.svg"),
              titulo: "Projetos Integradores",
              rota: "/admin/crud/projetos-integradores",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/recursos-video.svg"),
              titulo: "Videos",
              rota: "/admin/crud/videos",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/recursos-videoaulas.svg"),
              titulo: "Videoaulas Animação",
              rota: "/admin/crud/videoaulas-animacoes",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/menu-livro.svg"),
              titulo: "Livros",
              rota: "/admin/crud/livros",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/recursos-infograficos.svg"),
              titulo: "Conteúdos Abertos",
              rota: "/admin/conteudo-aberto",
              ativo: false,
            },
          ],
        },

        {
          titulo: "Assessoria pedagógica",
          icon: require("@assets/icones/menu-assessoria.svg"),
          group: true,
          itens: [
            {
              icon: require("@/assets/icones/menu-eventos.svg"),
              titulo: "Encontros Pedagógicos",
              rota: "/admin/crud/encontros-pedagogicos",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/menu-mensagens.svg"),
              titulo: "Informações",
              rota: "/admin/crud/informacoes",
              ativo: false,
            },
            {
              icon: require("@/assets/icones/menu-livro.svg"),
              titulo: "Conteúdo de Apoio",
              rota: "/admin/crud/conteudo-apoio",
              ativo: false,
            },
          ],
        },

        {
          titulo: "Marketing Educacional",
          icon: require("@assets/icones/recursos-sequencia-didatica.svg"),
          rota: "/admin/crud/marketing-educacional",
        },
        {
          titulo: "Banner",
          icon: require("@assets/icones/menu-banner.png"),
          rota: "/admin/crud/banner-home",
        },
        {
          titulo: "Obras",
          icon: require("@assets/icones/menu-livro.svg"),
          rota: "/admin/crud/obras",
        },
        {
          titulo: "Disciplinas",
          icon: require("@assets/icones/disciplinas.png"),
          rota: "/admin/crud/disciplinas",
        },
        {
          titulo: "Escolas",
          icon: require("@assets/icones/menu-home.svg"),
          rota: "/admin/crud/escolas",
        },
        {
          titulo: "Contratos",
          icon: require("@assets/icones/menu-relatorios.svg"),
          rota: "/admin/crud/contratos",
        },
        {
          icon: require("@assets/icones/apoio-turmas.svg"),
          titulo: "Turmas",
          rota: "/admin/crud/turmas",
          ativo: false,
        },
        {
          icon: require("@assets/icones/projetos-integradores.svg"),
          titulo: "Usuários",
          rota: "/admin/crud/usuarios",
          ativo: false,
        },
        {
          icon: require("@assets/icones/compartilhar.png"),
          titulo: "Compart. PNLD",
          rota: "/admin/pnld",
          ativo: false,
        },
        {
          titulo: "Sair",
          icon: require("@assets/icones/menu-sair.svg"),
          rota: "sair",
        },
      ],
    };
  },
  methods: {
    sair() {
      this.modalSairAberto = false;
      this.$router.push('/sair');
    }
  },
  watch: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 600;
    },
  },
  created() {
    this.isMenuOpen = this.menuOpen;
  },
};
</script>